import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from "vue";
import { UserSelfDocumentApiModel } from "../../api-models";
import SideNav from "./side-nav/side-nav.vue";
import TopNav from "./top-nav.vue";
import GuestTopNav from "./guest-top-nav.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gyre-navbars',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props;

const sideNavIsOpen = ref(false);

watch(sideNavIsOpen, (isOpen) => {
  const searchButtonElement = document.getElementById("search-button");
  if (!searchButtonElement) {
    return;
  }

  if (isOpen) {
    searchButtonElement.style.pointerEvents = "none";
  } else {
    setTimeout(() => {
      searchButtonElement.style.pointerEvents = "auto";
    }, 1);
  }
});

const shouldSeeRestrictedNavigation = computed(() => {
  const isFullMember = props.model.platformPermissions.includes("FullMembershipAccess");
  const isAssessPlanUser = props.model.platformPermissions.includes("AssessPlanAccess");
  const isFullMemberWithAssessPlanLicence = isFullMember && isAssessPlanUser;
  const isPlatformAdmin = props.model.platformPermissions.includes("AdministerPlatform");
  return (
    !isFullMember ||
    isFullMemberWithAssessPlanLicence ||
    isPlatformAdmin ||
    !props.model.hasCompletedFoundationsSession
  );
});

function openSideNav(): void {
  sideNavIsOpen.value = true;
}

function setSideNavIsOpen(isOpen: boolean): void {
  sideNavIsOpen.value = isOpen;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navigation", { 'side-nav-is-open': sideNavIsOpen.value }])
  }, [
    (!shouldSeeRestrictedNavigation.value)
      ? (_openBlock(), _createBlock(TopNav, {
          key: 0,
          model: _ctx.model,
          onOpenSideNav: openSideNav,
          "side-nav-is-open": sideNavIsOpen.value
        }, null, 8, ["model", "side-nav-is-open"]))
      : _createCommentVNode("", true),
    (shouldSeeRestrictedNavigation.value)
      ? (_openBlock(), _createBlock(GuestTopNav, {
          key: 1,
          model: _ctx.model
        }, null, 8, ["model"]))
      : _createCommentVNode("", true),
    (!shouldSeeRestrictedNavigation.value)
      ? (_openBlock(), _createBlock(SideNav, {
          key: 2,
          "side-nav-is-open": sideNavIsOpen.value,
          onNavStateChanged: setSideNavIsOpen
        }, null, 8, ["side-nav-is-open"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})